// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"trancheTable_tableWrapper__zfnxR","blurred":"trancheTable_blurred__6zaWH"};